import React from 'react';
import { createComponent as createComponent$1 } from '@lit-labs/react';

const rename = str => str[0].toUpperCase() + str.slice(1).replace(/(-\w)/g, s => s[1].toUpperCase());
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
const createComponent = (elementClass, tagName, events = undefined) => {
  const component = createComponent$1({
    tagName,
    elementClass,
    react: React,
    events
  });
  component.displayName = rename(tagName);
  return component;
};

export { createComponent, createComponent as default };
